<!--光伏电站-发电量图表-->
<template>
  <div>
    <div>
      <!--"年，月，日" 下拉菜单开始-->
      <el-select v-model="echarts.period.value" placeholder="请选择"
                 @change="echartsMethods().period.handleChange($event)">
        <el-option v-for="item in echarts.period.optionsPeriod" :key="item.value" :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
      <!--"年，月，日" 下拉菜单结束-->

      <!--"日期" 选择开始-->
      <el-date-picker v-model="echarts.datePicker.value" :type="echarts.datePicker.type"
                      :picker-options="echarts.datePicker.pickerOptions"
                      @change="echartsMethods().selectTime($event)"
                      placeholder="选择日期">
      </el-date-picker>
      <!--"日期" 选择结束-->

      <el-button type="primary" @click="echartsMethods().findGenAndPeriodEC()">查询</el-button>
      <el-button @click="echartsMethods().period.reset()">重置</el-button>
      <el-button type="primary" size="small" plain icon="el-icon-download"
                 v-if="judgeAuthority('zixitong:guangfu:photovoltaicStation:export')"
                 style="margin-right: 20px;float: right;margin-top:5px" @click="echartsMethods().exportExcel()">EXCEL
      </el-button>
    </div>
    <my-divider height="10px"></my-divider>
    <div class="container-echarts">
      <OmitLine v-if="echarts.chartsData.xData.length > 0" :id="'divCharts000'"
                :chartsData="echarts.chartsData"/>
      <div v-else>
        <my-divider height="100px"></my-divider>
        <el-empty description="无数据"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import MyDivider from "@/components/MyDivider";
import OmitLine from "@/components/EChartsFolder/OmitLine";
import api from "@/api";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
import {judgeAuthority} from "@/assets/js/utils";

export default {
  name: "PowerQuantityCharts",
  components: {OmitLine, MyDivider},
  created() {
    this.echartsMethods().period.initDatePicker();

    setTimeout(() => {
      this.echartsMethods().findGenAndPeriodEC();
    }, 500)

  },
  data() {
    return {
      echarts: {
        period: {
          optionsPeriod: [
            {
              value: "年",
              label: "年",
            },
            {
              value: "月",
              label: "月",
            },
            {
              value: "日",
              label: "日",
            },
          ],
          value: "日",
        },
        datePicker: {
          value: "",
          type: "date",
          pickerOptions:{
            disabledDate(time) {
              return time.getTime() > Date.now();
            },
          }
        },
        /*"图表数据" 开始*/
        chartsData: {
          name: "用电量",
          xData: ["01:00",],
          yData: [1],
          unit: "kw·h",
        },
        /*"图表数据" 结束*/
      }
    }
  },
  methods: {
    judgeAuthority,
    echartsMethods() {
      let that = this;
      return {
        selectTime(val){
          that.echartsMethods().findGenAndPeriodEC();
        },
        period: {
          handleChange(val) {
            if (val === "年") {
              that.echarts.datePicker.type = "year";
            } else if (val === "月") {
              that.echarts.datePicker.type = "month";
            } else if (val === "日") {
              that.echarts.datePicker.type = "date";
            } else {
              that.echarts.datePicker.type = "date";
            }

            that.echartsMethods().findGenAndPeriodEC();
          },
          initDatePicker() {
            that.echarts.datePicker.value = that.$moment().format("YYYY-MM-DD");
          },
          reset() {
            that.echarts.datePicker.type = "date";
            that.echarts.datePicker.value = that.$moment().format("YYYY-MM-DD");
            that.echarts.period.value = "日";
          },
        },
        async findGenAndPeriodEC() {
          let periodEcharts = that.echarts.period.value;
          let period;
          let format;
          if (periodEcharts === "日") {
            period = "hour";
            format = "HH:mm";
          } else if (periodEcharts === "月") {
            period = "day";
            format = "MM-DD";
          } else if (periodEcharts === "年") {
            period = "month";
            format = "YYYY-MM";
          } else {
            period = "hour";
            format = "HH:mm";
          }

          const startTimeDay = parseInt(
              that
                  .$moment(that.echarts.datePicker.value)
                  .startOf("day")
                  .format("x")
          ); // 当天零点时间戳
          const endTimeDay = parseInt(
              that.$moment(that.echarts.datePicker.value).endOf("day").format("x")
          ); // 当天23:59:59时间戳

          const startTimeMonth = parseInt(
              that
                  .$moment(that.echarts.datePicker.value)
                  .startOf("month")
                  .format("x")
          ); // 本月1号零点时间戳
          const endTimeMonth = parseInt(
              that
                  .$moment(that.echarts.datePicker.value)
                  .endOf("month")
                  .format("x")
          ); // 本月31号23:59:59时间戳

          const startTimeYear = parseInt(
              that
                  .$moment(that.echarts.datePicker.value)
                  .startOf("year")
                  .format("x")
          ); // 本年1月1号零点时间戳
          const endTimeYear = parseInt(
              that
                  .$moment(that.echarts.datePicker.value)
                  .endOf("year")
                  .format("x")
          ); // 本年12月31号23:59:59时间戳

          let startTime = 0;
          let endTime = 0;
          if (periodEcharts === "日") {
            startTime = startTimeDay;
            endTime = endTimeDay;
          } else if (periodEcharts === "月") {
            startTime = startTimeMonth;
            endTime = endTimeMonth;
          } else if (periodEcharts === "年") {
            startTime = startTimeYear;
            endTime = endTimeYear;
          } else {
            startTime = startTimeDay;
            endTime = endTimeDay;
          }

          let keyArr = [];
          that.echarts.chartsData.xData = [""];
          that.echarts.chartsData.yData = [0];
          let params = {
            startTime: startTime,
            endTime: endTime,
            period: period,
            needPeriodEc: false,
            isPower: false,
          };
          if (that.entity.type === "project") {
            params.projectId = that.entity.id;
          } else if (that.entity.type === "station") {
            params.stationId = that.entity.id;
          } else if (that.entity.type === "inverter") {
            params.inverterId = that.entity.id;
          } else {
            params.projectId = that.entity.id;
          }

          let res = await api.photovoltaicFindGenAndPeriodEC(params);
          let tsValue = res.data.data["tsValue"];
          for (let key in tsValue) {
            keyArr.push(parseInt(key));
          }
          keyArr.sort((a, b) => {
            return a - b;
          });

          let xData = [];
          let yData = [];

          keyArr.forEach((value) => {
            let timestamp = that.$moment(value).format(format);
            xData.push(timestamp);
            yData.push(tsValue[value]["EC_Hour"].toFixed(2));
          });

          that.echarts.chartsData.xData = xData;
          that.echarts.chartsData.yData = yData;
        },
        exportExcel() {
          console.log("导出数据");

          let datePickerValueYear = that
              .$moment(that.echarts.datePicker.value)
              .format("YYYY");
          let datePickerValueMonth = that
              .$moment(that.echarts.datePicker.value)
              .format("YYYY-MM");
          let datePickerValueDate = that
              .$moment(that.echarts.datePicker.value)
              .format("YYYY-MM-DD");

          let datePickerType = that.echarts.datePicker.type;
          let xData = that.echarts.chartsData.xData;
          xData = xData.map((item) => {
            if (datePickerType === 'year') {
              return item;
            } else if (datePickerType === 'month') {
              return datePickerValueYear + "-" + item
            } else if (datePickerType === 'date') {
              return datePickerValueDate + " " + item
            } else {
              return datePickerValueDate + " " + item
            }
          });

          let yData = that.echarts.chartsData.yData;

          let id = that.entity.id;
          let name = that.entity.name;
          let type = that.entity.type;

          if (type === "project") {
            name = "全部电站";
          }

          let th = ["时间"];
          th.push(`发电量(kw·h)`);
          // 内容区
          let content = [];
          for (let i = 0; i < xData.length; i++) {
            let row = [];
            row.push(xData[i]);
            row.push(yData[i]);
            content.push(row);
          }

          let filename = name + '-' + '发电量' + '-';
          if (datePickerType === 'year') {
            filename += datePickerValueYear;
          } else if (datePickerType === 'month') {
            filename += datePickerValueMonth;
          } else if (datePickerType === 'date') {
            filename += datePickerValueDate;
          } else {
          }

          exportFile.xlsxFile(XLSX, `${filename}`, {
            excel: [th, ...content],
          });
        },
      }
    }
  },
  props: {
    /**
     * @description 此实体格式为{id: '', type: '', name: ''}。
     * @description id：实体id。
     * @description type：实体类型：project（项目），station（电站），inverter（逆变器）。
     * @description 因为不同的实体类型需要传递不同的参数，所以需要type属性表明是哪种实体类型。
     * @description 具体规则如下。
     * @description type=project, 接口为：http://xxx?projectId=xxx。
     * @description type=station, 接口为：http://xxx?stationId=xxx。
     * @description type=inverter, 接口为：http://xxx?inverterId=xxx。
     * @description type的取值范围为project/station/inverter,三取一。
     * @description name：实体名称，如果type=project,则name=全部电站。如果type=station，则name=电站名称。如果type=inverter,则name=逆变器名称。
     * */
    entity: {
      type: Object,
      default() {
        return {id: '', type: '', name: ''}
      }
    },
  },
  watch: {
    'entity': {
      handler(newVal, oldVal) {
        this.echartsMethods().findGenAndPeriodEC();
      }
    },
  }
}
</script>

<style scoped lang="scss">
div.container-echarts {
  width: 100%;
  height: 615px;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  margin-right: 10px;
}

.el-select {
  margin-right: 10px;
  width: 100px;
}

</style>
